import './Step.css'
import cx from 'classnames'
import React from 'react'
import { CheckIcon, DashedCircleIcon } from '../icons'

type StepStates = 'completed' | 'active' | 'inactive'

const stateClasses: Record<StepStates, string> = {
  completed: 'step-completed',
  active: 'step-active',
  inactive: 'step-inactive'
}

const sizeClasses = {
  xs: 'step-xs',
  sm: 'step-sm',
  md: 'step-md',
  lg: 'step-lg'
}

export function Step({
  className,
  sizeType = 'md',
  children,
  state = 'active'
}: {
  children: React.ReactNode
  className?: string
  state?: StepStates
  sizeType?: 'xs' | 'sm' | 'md' | 'lg'
}) {
  return (
    <div className={cx('step-base', stateClasses[state], sizeClasses[sizeType], className)}>
      {state === 'completed' && <CheckIcon className="step-icon-completed" />}
      {(state === 'active' || state === 'inactive') && (
        <DashedCircleIcon className="step-icon-default" />
      )}
      {children}
    </div>
  )
}
